import styled from 'styled-components';

import Image from 'components/Image';
import RichText from 'components/RichText';

import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';
import TYPO from 'styles/typography';

const Section = styled.section`
  padding-top: 113px;
  background: linear-gradient(
    ${COLORS.pinkMuted.opacity(0.5)} 65%,
    ${COLORS.sky} 35%
  );
  color: ${COLORS.velvety};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  ${BREAKPOINTS.medium`
    padding-top: 220px;
  `}

  ${BREAKPOINTS.large`
    padding-top: 0;
    min-height: 100vh;
    background: ${COLORS.pinkMuted.opacity(0.5)};
  `}
`;

const Title = styled(RichText)`
  margin-bottom: 40px;
  text-align: center;

  * {
    ${TYPO.h3}
  }

  u {
    color: ${COLORS.dawn};
  }

  ${BREAKPOINTS.medium`
    margin-bottom: 92px;
  `}

  ${BREAKPOINTS.large`
    margin-bottom: 0;
  `}
`;

const ImageWrapper = styled.div`
  min-width: 275px;
  width: 62%;
  height: auto;
  transform: translate(-40%, 20%) rotate(-13deg);
  z-index: 10;

  &:nth-child(odd) {
    margin-bottom: -5%;
    transform: translate(40%, -38%) rotate(9deg);
    z-index: 0;
  }

  ${BREAKPOINTS.large`
    display: none;
  `}
`;

const ImageStyled = styled(Image)`
  &&& {
    width: auto;
    height: auto;
  }
`;

const FoodAndDrink = ({ title, images }) => {
  return (
    <Section>
      <Title html={title?.html} />
      {images?.map((image, i) => (
        <ImageWrapper key={i}>
          <ImageStyled image={image} />
        </ImageWrapper>
      ))}
    </Section>
  );
};

export default FoodAndDrink;
